/**
 * Swiper初期化（グローバルのSwiperを使用）
 */
export function initSwipers() {
  // Hero Swiper
  setTimeout(function () {
    new window.Swiper('.akb-hero__swiper', {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: 2000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.akb-hero-pagination',
        clickable: true,
      },
    });
  }, 3000);

  // News Swiper (モバイルのみ)
  if (768 > window.innerWidth) {
    new window.Swiper('.akb-news__swiper', {
      autoplay: false,
      breakpoints: {
        767: {
          autoplay: { delay: 5000 },
          loop: true,
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: '.news-next',
            prevEl: '.news-prev',
          },
        },
      },
    });
  }

  // Events Swiper
  // スライド数が表示数以下だと loop でスライドが複製され、同じイベントが
  // 連続表示される。十分な枚数（PC最大表示数=4超）のときだけ loop/autoplay を有効化する。
  const eventsContainer = document.querySelector('.swiper-container');
  if (eventsContainer) {
    const eventsSlideCount = eventsContainer.querySelectorAll('.swiper-slide').length;
    const eventsLoop = eventsSlideCount > 4;
    new window.Swiper('.swiper-container', {
      autoplay: eventsLoop ? { delay: 5000 } : false,
      loop: eventsLoop,
      slidesPerView: 4,
      spaceBetween: 20,
      navigation: {
        nextEl: '.slider-next',
        prevEl: '.slider-prev',
      },
      breakpoints: {
        767: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });
  }

  // Flower Swiper
  new window.Swiper('.topFlower__slide', {
    loop: false,
    slidesPerView: 6,
    spaceBetween: 40,
    centeredSlides: false,
    breakpoints: {
      767: {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
      },
      900: {
        loop: true,
        slidesPerView: 3.5,
        spaceBetween: 20,
        centeredSlides: true,
        autoplay: { delay: 5000 },
      },
      1100: {
        loop: true,
        slidesPerView: 4.5,
        spaceBetween: 20,
        centeredSlides: true,
        autoplay: { delay: 5000 },
      },
      1200: {
        loop: true,
        slidesPerView: 5.5,
        spaceBetween: 20,
        centeredSlides: true,
        autoplay: { delay: 5000 },
      },
    },
  });

  // World/Section Frame Swiper
  new window.Swiper('.akb-section-frame__slider', {
    loop: true,
    slidesPerView: 3,
    spaceBetween: 60,
    pagination: {
      el: '.world-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.world-next',
      prevEl: '.world-prev',
    },
    breakpoints: {
      767: {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 50,
        centeredSlides: true,
      },
    },
  });
}
